__turbopack_context__.v({
  "gentleLink": "MatchingEventBanner-module__fnsJIa__gentleLink",
  "icon": "MatchingEventBanner-module__fnsJIa__icon",
  "logo": "MatchingEventBanner-module__fnsJIa__logo",
});
